export const GET_COACH_STATUSES_REQUEST = "GET_COACH_STATUSES_REQUEST"
export const GET_COACH_STATUSES_SUCCESS = "GET_COACH_STATUSES_SUCCESS"
export const GET_COACH_STATUSES_ERROR = "GET_COACH_STATUSES_ERROR"
export const GET_COACH_STATUS_REQUEST = "GET_COACH_STATUS_REQUEST"
export const GET_COACH_STATUS_SUCCESS = "GET_COACH_STATUS_SUCCESS"
export const GET_COACH_STATUS_ERROR = "GET_COACH_STATUS_ERROR"
export const CREATE_COACH_STATUS_REQUEST = "CREATE_COACH_STATUS_REQUEST"
export const CREATE_COACH_STATUS_SUCCESS = "CREATE_COACH_STATUS_SUCCESS"
export const CREATE_COACH_STATUS_ERROR = "CREATE_COACH_STATUS_ERROR"
export const EDIT_COACH_STATUS_REQUEST = "EDIT_COACH_STATUS_REQUEST"
export const EDIT_COACH_STATUS_SUCCESS = "EDIT_COACH_STATUS_SUCCESS"
export const EDIT_COACH_STATUS_ERROR = "EDIT_COACH_STATUS_ERROR"
export const DELETE_COACH_STATUS_REQUEST = "DELETE_COACH_STATUS_REQUEST"
export const DELETE_COACH_STATUS_SUCCESS = "DELETE_COACH_STATUS_SUCCESS"
export const DELETE_COACH_STATUS_ERROR = "DELETE_COACH_STATUS_ERROR"